import React, { useEffect, useState, useRef, useMemo } from "react";
import {
  Box,
  CircularProgress,
  Container,
  Grid,
  Typography,
} from "../../imports/muiImport";
import { useLocation, useSearchParams } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import InfiniteScroll from "react-infinite-scroll-component";
import ProductCardsList from "./LARGEDEVICE/ProductCardsList";
import { getAllProducts, useSelector } from "../../imports/generalImport";
import ProductFilterMobile from "./MEDIUMDEVICE/mobileProductFilter";

// ============================================================
// ARRANGEMENT CONFIG — arrays are node.id (UUIDs)
// ============================================================
export const rearrangedProducts = {
  categories: [
    {
      name: "Apparel",
      slug: "apparel",
      id: "d9617f26-72b9-4674-9f52-2b78883e835a",
      data: [
        "b52a625b-aad3-4084-a283-da777dacdf7e",
        "6b76b7fb-c4dc-4a32-b6d9-2a410474c246",
        "37253878-5f59-4db0-bc93-9565059620ca",
        "0f7f3b74-0036-4730-a2ca-2384b142d0f7",
        "ee0e47b8-f0c0-4adb-a167-1f222c38e09e",
        "f63b162a-0cbb-4b2f-9c89-1d2acd65c2c4",
        "9b5435d6-f6ca-443b-99ea-c53131f981e0",
        "0f8d03d6-f74b-4972-8f09-d2d9402e94a1",
        "cbfe4c40-9af7-4795-8d58-080d72a577e4",
        "8639d881-13e4-4972-8873-e71b887e3a82",
        "a2898891-f9fa-47f4-ad4b-c8eb3fccddfc",
        "28a49022-5525-4098-a63b-c9bcb8248a57",
        "36faed77-a1dc-483e-91eb-84fed18a68fb",
        "18f2a9ad-6e2e-4ee5-b4d9-ddf9dc2add82",
        "ea5755f9-89ff-46d9-b1b8-40c8436e91ad",
        "3e95e6af-8302-4806-988c-78a853645131",
        "b801bd77-d88b-49af-94e0-0fbe240cd1a0",
        "5c67d777-8c8b-46ef-8c55-de14df4223ab",
        "2d6d4bf4-a97d-4bc3-b9cd-335eef97746a",
        "7db68710-4f31-417b-947b-11e307708b1d",
        "156fa134-7095-40d5-8873-e4c4f07567ba",
        "6018a312-3d31-49e6-9e98-b116500d7bbd",
        "f3ac9566-b32c-477c-a869-3f4dee2e58a1",
        "2cc31d50-cde3-414d-ac4c-3fb0927c0cb3",
        "17f24c58-d164-4bde-ba9d-881b386c5c84",
        "31cc42a1-0399-4b37-bbd5-08b0f6b3aaa2",
        "11ea0863-4213-4c0d-8968-a6d4c470372a",
        "4d0f4ced-12f4-41b3-9c6f-7da9cee459d7",
        "024b9a18-d1d7-4de9-80d3-368c080a6d86",
        "1f38a75f-52bf-47dc-a38f-e51f1e34af30",
        "8114bed6-4c0b-4f2f-847c-8def1b1acdca",
        "1f96a289-a107-4485-94bb-407b8aa68b10",
        "532feb82-4770-43f0-9b19-792bf27463da",
        "1d26826a-2c4b-4d24-8860-50100668b877",
        "66f35f3f-1246-4139-891e-db10534a69e5",
        "698bfeb3-e3e6-4f1d-bc82-66261e667868",
        "73427134-b54f-4f20-93f6-de52420f162d",
        "aa40ca73-addc-4cfb-8e61-dc47e7434f66",
        "a56b80b8-7a09-470b-96b8-7e3cc185e19e",
        "849df550-9892-43ab-b0d2-c8c861d928dc",
        "77d0463b-e71c-417d-b1db-f1e8d3a327be",
        "7c2aefe8-355f-4547-8a37-f24abbf487b8",
        "acc0860b-0833-425e-a05a-751e734bab1e",
        "aaf748ca-c43b-44e1-bfe2-c8bba27ae8d7",
        "a5328e05-eb18-4844-aa36-676533bbbc63",
        "81f658e1-3c92-4750-828e-f08351c4512e",
        "749da29f-f2c5-4c30-95d6-a05a5d541a74",
        "b85f858b-a012-470d-94c0-849f7064a246",
        "cd674657-5de7-4085-b529-e844e9087eca",
        "03b5a440-5c29-49a5-a54f-707317ecac00",
        "41eb7fb1-b18f-44d0-a359-fc1414c1e7a9",
        "0455d51b-3b08-4da5-b2ab-d7dd373d72d5",
        "285fc763-b379-498b-a535-71caf8beebd9",
        "2fe0aedb-0705-4782-91bf-a7525ebf7e5a",
        "2f26fc03-8040-43c8-9322-a21083814954",
        "413a5d31-22ce-487e-8b47-60de151907ea",
        "4d15c910-481d-4909-89da-c11a352e6987",
        "442a462c-fc9d-41da-a2de-30cf336f8b1a",
        "48a9c646-a0d2-4c42-9212-d0394f150f59",
        "48590c4a-08ec-4abd-a76a-19ecedb5477e",
        "4361aa37-d915-4acd-9a77-9cd583af9e41",
        "5fe687f1-2976-465a-b22b-ffa9056bdba8",
        "1cf59ade-2f83-4506-876a-b25737c141d5",
        "69a49cdc-5ade-4c13-9730-2dce2e2bd782",
        "a58e98be-9470-478d-a8b0-629b6ec00ba6",
        "965fcfbc-703c-4fef-8652-6fdfd82b833d",
        "6f61cc78-91d7-4d54-b4c8-31ab6be68f09",
        "97ed4c89-6838-4361-b6f5-545c198050d5",
        "90b3a0d1-bbf9-47d4-8754-79e3aa40b3ca",
        "d51094a8-27ec-4967-b8fe-6baf17ca9ae6",
        "6e1c9c34-d51b-4346-9c6e-5dccf5225df7",
        "9ee9afd3-6124-471a-8618-2fb62a65dbcd",
        "a7be4e82-150a-4650-a22e-ee714d3d46d7",
        "a948670b-77e0-433b-8610-754709bce453",
        "aa120918-5a84-4b28-8d23-93f3db96aa2f",
        "a97cee46-67b0-4987-a831-da51bb4112c9",
        "aac85943-fad3-4c09-8aa2-deba1c808353",
        "ad179eb1-f946-469b-ae12-a9acb52a6eff",
        "afacd5c8-f81e-4fff-af84-231514b166a6",
        "ba640ab1-b3bd-40ab-9c5e-742dca6183ef",
        "c2f8aa1e-664c-425a-934c-fa0c02ee3afc",
        "c51314c4-c17d-4177-ba25-071c61a21585",
        "f4a7d20a-4f6b-4e8a-bff5-de256e6a9cfd",
        "e679117c-3f60-4d7b-9c0c-20b5d8c2405e",
        "dd11213e-4971-4a8e-8c03-9a67b7702990",
        "ea961226-6449-4e43-8879-6264006d2de3",
        "e8f4a9fa-4525-4c7e-8575-fe11b1670669",
        "ecab08f2-b2a1-418d-ac30-4d6f70e1c548",
        "faad18e2-db20-42e2-a2d2-62115df00a0f",
        "ed4ffea0-d9d1-4448-8d78-efb3ea3230a3",
        "fb80c4c1-edf7-440f-943b-65ff5c3447ae",
        "fe4f315f-f63f-403e-ac69-349899b6b333",
      ],
    },
    {
      name: "Entertainment",
      // slug: "entertainment",
      id: "e55c20bb-7e79-42a8-8bd7-d46fc97bd793",
      data: [
        "c95f9b99-4918-45fc-b9ac-f2e824db563a",
        "56b56a7b-b432-474d-a22d-d024b573a176",
        "6560c948-c657-4b9e-9a31-9d76795a1be1",
        "fb6bd19d-e195-4f03-8f10-9d0e064a53a0",
        "cfd1a870-05dd-4c32-978c-89d2825bcd42",
        "660a474b-457f-48ac-b5ab-bd6baa1b4eac",
        "a70d5a04-2ec4-43cd-95a5-46da8f45ce12",
        "aeb2717f-b350-4864-b002-de0261f85646",
        "ccb69007-3931-4506-862b-5fb2c6c1cf9c",
        "d932d356-07df-42ba-a34e-84d8d6361880",
        "f945816e-f525-4219-8bf4-5808b55eea6f",
      ],
    },
  ],
};

// ============================================================
// HANDLER — matches by node.id (UUID)
// Accepts category UUIDs (already resolved from slug by caller)
// ============================================================
export const rearrangedProductHandler = (categoryIds, products) => {
  if (!categoryIds?.length) return products;

  const matchedCategory = rearrangedProducts.categories.find((cat) =>
    categoryIds.includes(cat.id)
  );

  if (!matchedCategory || !matchedCategory.data?.length) return products;

  const order = matchedCategory.data;

  const activeProducts = products
    .filter((item) => item?.node?.isActive)
    .sort((a, b) => {
      const ai = order.indexOf(a?.node?.id);
      const bi = order.indexOf(b?.node?.id);
      return (ai === -1 ? Infinity : ai) - (bi === -1 ? Infinity : bi);
    });

  let i = 0;
  return products.map((item) =>
    item?.node?.isActive ? activeProducts[i++] : item
  );
};

const MobileAllGiftCardPage = () => {
  const categories = useSelector((state) => state?.Dashboard?.categories);
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [hasMore, setHasMore] = useState(false);
  const [endCursor, setEndCursor] = useState(null);
  const [searchParams, setSearchParams] = useSearchParams();
  const isFetchingMoreRef = useRef(false);

  const searchItem = useLocation();
  const canonicalUrl = `https://www.99gift.ae/${searchItem.pathname}`;

  // ---- URL reads SLUGS ----
  const categorySlugParam = searchParams.get("categorySlug");
  const categorySlugs = useMemo(
    () => (categorySlugParam ? categorySlugParam.split(",").filter(Boolean) : []),
    [categorySlugParam]
  );

  // ---- Resolve slugs -> UUIDs (for the rearranger) ----
  const categoryIds = useMemo(
    () =>
      categorySlugs
        .map(
          (slug) =>
            rearrangedProducts.categories.find((c) => c.slug === slug)?.id
        )
        .filter(Boolean),
    [categorySlugs]
  );

  // Initial Fetch Products
  useEffect(() => {
    const fetchProducts = async () => {
      try {
        setLoading(true);

        const payload = {
          limit: 1000,
        };

        // API receives SLUGS
        if (categorySlugs.length > 0) {
          payload.categorySlug = categorySlugs;
        }

        const response = await getAllProducts(payload);

        if (response?.success) {
          // Rearranger receives UUIDs
          const shuffledProducts = rearrangedProductHandler(
            categoryIds,
            response?.data?.edges || []
          );
          setProducts(shuffledProducts || []);
          setHasMore(Boolean(response?.data?.pageInfo?.hasNextPage));
          setEndCursor(response?.data?.pageInfo?.endCursor || null);
        } else {
          setProducts([]);
          setHasMore(false);
          setEndCursor(null);
        }
      } catch (error) {
        console.error("Error fetching products:", error);
        setProducts([]);
        setHasMore(false);
        setEndCursor(null);
      } finally {
        setLoading(false);
      }
    };

    fetchProducts();
  }, [searchParams]);

  // Fetch More Products for Infinite Scroll
  const fetchMoreProducts = async () => {
    if (!hasMore || !endCursor || isFetchingMoreRef.current) return;

    try {
      isFetchingMoreRef.current = true;
      const payload = {
        limit: 8,
        after: endCursor,
      };

      if (categorySlugs.length > 0) {
        payload.categorySlug = categorySlugs;
      }

      const response = await getAllProducts(payload);

      if (response?.success) {
        const newEdges = response?.data?.edges || [];
        setProducts((prev) => [...prev, ...newEdges]);
        setHasMore(Boolean(response?.data?.pageInfo?.hasNextPage));
        setEndCursor(response?.data?.pageInfo?.endCursor || null);
      } else {
        setHasMore(false);
      }
    } catch (error) {
      console.error("Error fetching more products:", error);
      setHasMore(false);
    } finally {
      isFetchingMoreRef.current = false;
    }
  };

  // Page title based on selected SLUGS
  const pageTitle =
    categorySlugs.length > 0
      ? categories
        ?.filter((cat) => categorySlugs.includes(String(cat?.slug)))
        .map((cat) => cat.name)
        .join(", ")
      : "All Gift Cards";

  return (
    <>
      <Helmet>
        <title>Explore the Best Gift Cards</title>
        <link rel="canonical" href={canonicalUrl} />
      </Helmet>

      <Container maxWidth="xl" sx={{ px: { xs: 0, sm: 2, md: 0 } }}>
        {/* MOBILE CATEGORY SLIDER */}
        <Box
          sx={{
            display: { xs: "block", sm: "block", md: "none" },
            overflowX: "auto",
            whiteSpace: "nowrap",
            "&::-webkit-scrollbar": { display: "none" },
          }}
        >
          <ProductFilterMobile
            categorySlugs={categorySlugs}
            setSearchParams={setSearchParams}
          />
        </Box>

        <Grid container spacing={3} id="target-section">
          <Grid
            item
            xs
            sx={{
              borderLeft: { xs: "none", md: "2px solid #E4C18F" },
            }}
          >
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                mb: { xs: 2, sm: 4 },
                mt: { xs: 1, sm: 2 },
                mr: { xs: 0, sm: 2, md: 3 },
              }}
            >
              <Typography
                sx={{
                  fontWeight: 600,
                  fontSize: { xs: "20px", sm: "24px", md: "30px" },
                  color: "primary.main",
                  fontFamily: "Onest",
                  lineHeight: 1.2,
                }}
              >
                {pageTitle}
              </Typography>
            </Box>

            <InfiniteScroll
              dataLength={products?.length || 0}
              next={fetchMoreProducts}
              hasMore={hasMore}
              scrollThreshold={0.8}
              loader={
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    py: 3,
                    width: "100%",
                  }}
                >
                  <CircularProgress size={28} sx={{ color: "primary.main" }} />
                </Box>
              }
              endMessage={
                products.length > 0 ? (
                  <Box sx={{ textAlign: "center", py: 3 }}>
                    <Typography
                      sx={{
                        fontFamily: "Be Vietnam Pro",
                        fontSize: "13px",
                        color: "text.secondary",
                        fontWeight: 500,
                      }}
                    >
                      You've seen all products
                    </Typography>
                  </Box>
                ) : null
              }
              style={{ overflow: "visible" }}
            >
              <ProductCardsList products={products} loading={loading} />
            </InfiniteScroll>
          </Grid>
        </Grid>
      </Container>
    </>
  );
};

export default MobileAllGiftCardPage;